import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsTransformationsTransformationId } from "./constants";
import type {
  ValidateTransformationRequest,
  ValidateTransformationResponse,
} from "@dashboardApi/apis/dataTransformation/types";
import fetch from "@lib/fetch";

export const validateTransformation = reactQueryMutationAdapter(
  appsTransformationsTransformationId,
  async (request: ValidateTransformationRequest): Promise<ValidateTransformationResponse> => {
    return fetch(`/apps/transformations/${request.transformation_id}/validate`, "POST", request);
  }
);
